/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    code: "code",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "How do I fix flickering text after server side rendering?"
    }), "\n", _jsxs(_components.p, {
      children: ["When using global styling APIs like ", _jsx(_components.a, {
        href: "/docs/api#createglobalstyle",
        children: _jsx(_components.code, {
          children: "createGlobalStyle"
        })
      }), " or the former ", _jsx(_components.a, {
        href: "/docs/api#injectglobal",
        children: _jsx(_components.code, {
          children: "injectGlobal"
        })
      }), ", adding and removing certain styles from the DOM like ", _jsx(_components.code, {
        children: "@font-face"
      }), " definitions can cause momentary flickering of text on the page. This typically happens during the rehydration phase of server-side rendering. We're still tweaking how these behaviors work to avoid the issue long-term."]
    }), "\n", _jsxs(_components.p, {
      children: ["However, there is a CSS solution to the problem in the ", _jsxs(_components.a, {
        href: "https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display",
        children: [_jsx(_components.code, {
          children: "font-display"
        }), " CSS rule"]
      }), ". By setting the rule to \"fallback\" mode, once a font has been loaded it will not be reloaded. This eliminates the flicker."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: "@font-face {\n  font-family: 'Foo';\n  src: url('/path/to/foo.woff') format('woff');\n  font-style: normal;\n  font-weight: 400;\n  font-display: fallback; /* <- this can be added to each @font-face definition */\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
